import { combineReducers } from 'redux'
import { getGlobalReducers } from '../../../utils/reducers'
import { inputSlice } from './slices/input.slice'
import { outputSlice } from './slices/output.slice'
import { calculationReducerPath } from '../../../utils/selectors'

const calculationReducers = combineReducers({
  [inputSlice.name]: inputSlice.reducer,
  [outputSlice.name]: outputSlice.reducer,
})

export const rootReducer = combineReducers({
  [calculationReducerPath]: calculationReducers,
  ...getGlobalReducers(),
})
